module.exports = __webpack_public_path__ + "static/img/log_4.c0815f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log_4.jpg
// module id = DGrz
// module chunks = 1